import { PROMO_CODES_PATH } from 'modules/promo-codes/constants'
import { updateLegacyReduxAction } from 'modules/redux/actions/legacy/update'

/**
 * Resets the DomainNew to null.
 * @returns {Function}
 */
function resetPromoCodeAction () {
  const path = PROMO_CODES_PATH.NEW
  const value = null
  return updateLegacyReduxAction({
    path,
    value
  })
}

export default resetPromoCodeAction
